import { Icons, Paragraph } from '@hm-group/bads-react';
import styles from './MaintenancePage.module.css';

interface MaintenancePageProps {
  message?: string;
}

export function MaintenancePage({ message }: Readonly<MaintenancePageProps>) {
  return (
    <div className={styles.container}>
      <Icons.ErrorOutline width="100" height="100" />
      <h2 className={styles.title}>System Under Maintenance</h2>
      <Paragraph type="semi-bold">
        {message ?? 'The system is currently undergoing maintenance. Please try again later.'}
      </Paragraph>
    </div>
  );
}
